import React, { useState } from 'react';
import Checkbox from 'on_web/components/shared/Common/Checkbox/Checkbox';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

export default function CheckboxList(props) {
  const [items, setItems] = useState(props.items);

  const onCheckboxChange = (val, checked) => {
    if (props.onCheckboxChange) {
      props.onCheckboxChange(val, checked);
    }

    let deselectAllValue = props.deselectAllValue;
    let disableAllValue = props.disableAllValue;
    const additionalValues = props.additionalDisableAndDeselectValues;

    items.forEach(item => {
      if (val === deselectAllValue && checked === true) {
        if (
          props.excludeFromDeselectValues != null &&
          !props.excludeFromDeselectValues.includes(item.value)
        ) {
          item.checked = false;
        } else if (props.excludeFromDeselectValues == null) {
          item.checked = false;
        }
      }

      if (val !== deselectAllValue && checked === true) {
        items.forEach(item => {
          if (item.value === deselectAllValue) {
            if (
              props.excludeFromDeselectValues != null &&
              !props.excludeFromDeselectValues.includes(val)
            ) {
              item.checked = false;
            } else if (props.excludeFromDeselectValues == null) {
              item.checked = false;
            }
          }
        });
      }

      if (item.value === val) {
        item.checked = checked;
      } else if (val === disableAllValue) {
        if (
          props.excludeFromDeselectValues != null &&
          !props.excludeFromDeselectValues.includes(item.value)
        ) {
          item.disabled = checked;
        } else if (props.excludeFromDeselectValues == null) {
          item.disabled = checked;
        }
      }

      // values which, when at least one of them is checked, disable all other values other
      // than themselves and excluded values
      if (additionalValues && additionalValues.includes(val)) {
        if (
          props.excludeFromDeselectValues != null &&
          !props.excludeFromDeselectValues.includes(item.value) &&
          !additionalValues.includes(item.value)
        ) {
          if (checked) {
            item.checked = false;
            item.disabled = true;
          } else {
            let remainingChecked = 0;

            items.forEach(i => {
              if (
                additionalValues.find(j => j === i.value) &&
                i.checked === true
              ) {
                remainingChecked++;
              }
            });

            if (remainingChecked === 1) {
              item.disabled = false;
            }
          }
        } else {
          if (item.value === val) {
            item.checked = checked;
          }
        }
      }
    });

    setItems(items);
  };

  return (
    <Grid container>
      {items &&
        items.map((item, index) => (
          <Grid
            key={index}
            item
            xs={props.twoColumns ? 6 : 12}
            sm={props.twoColumns ? 6 : 12}
          >
            <Checkbox
              value={item.value}
              label={item.label}
              disabled={item.disabled}
              checked={item.checked}
              color={props.checkboxColor}
              height={props.checkboxHeight}
              width={props.checkboxWidth}
              labelFontSize={props.labelFontSize}
              labelPlacement={props.labelPlacement}
              onCheckboxChange={(val, checked) =>
                onCheckboxChange(val, checked)
              }
            />
            {props.dividerBelowItem && props.dividerBelowItem === index + 1 && (
              <Divider />
            )}
          </Grid>
        ))}
    </Grid>
  );
}

CheckboxList.propTypes = {
  twoColumns: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      checked: PropTypes.bool.isRequired,
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
    })
  ),
  dividerBelowItem: PropTypes.number,
  onCheckboxChange: PropTypes.func.isRequired,
  checkboxColor: PropTypes.string,
  checkboxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checkboxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  labelPlacement: PropTypes.oneOf(['bottom', 'end', 'start', 'top']),
};
